export var IdTeasers;
(function (IdTeasers) {
    IdTeasers["NoPlayerLeagueRunning"] = "NoEventRunning";
    IdTeasers["NoCoopLeagueRunning"] = "NoCoopLeagueRunning";
    IdTeasers["PlayerLevelTooLowPlayerLeague"] = "PlayerLevelTooLowPlayerLeague";
    IdTeasers["PlayerLevelTooLowCoop"] = "PlayerLevelTooLowCoop";
    IdTeasers["PlayerHasNoCoop"] = "PlayerHasNoCoop";
})(IdTeasers || (IdTeasers = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/IdTeasers.ts
// module id = 445
// module chunks = 3